var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';
/**
 *  Generates a list of error message elements for use with form groups
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ErrorMessages(_ref) {
  let {
    id,
    className,
    errors = [],
    showErrors,
    showIcon = true,
    ...rest
  } = _ref;
  const rootClassName = clsx(className, 'has-error');
  const renderErrors = typeof showErrors === 'undefined' ? !!errors.length : showErrors;
  return renderErrors && /*#__PURE__*/_jsx("div", {
    "data-cmp": "errorMessages",
    className: rootClassName,
    ...rest,
    children: [].concat(errors).map((errorMessage, key) => /*#__PURE__*/_jsxs("span", {
      className: "help-block validation-message error-message",
      id: id,
      role: "alert",
      "aria-live": "polite",
      children: [showIcon && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
        glyph: "danger"
      }))), ' ', errorMessage]
    }, `error-${key}`))
  });
}
export default ErrorMessages;